// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wnZ6","icon":"styles_icon__1fZk-"};